export const ActualJobsService = {
  getData() {
    return [
      {
        id: 1,
        operation: { label: 'подготовительные работы', key: 1 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 1',
          fullName: 'Исполнитель 1'
        },
        laborAccountingCoefficient: 0.33,
        comment: 'работы выполнили'
      },
      {
        id: 2,
        operation: { label: 'подготовительные работы', key: 1 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 2',
          fullName: 'Исполнитель 2'
        },
        laborAccountingCoefficient: 0.33,
        comment: 'работы выполнили'
      },
      {
        id: 3,
        operation: { label: 'подготовительные работы', key: 1 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 3',
          fullName: 'Исполнитель 3'
        },
        laborAccountingCoefficient: 0.33,
        comment: 'сделано'
      },
      {
        id: 4,
        operation: { label: 'транспортные работы', key: 2 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 1',
          fullName: 'Исполнитель 1'
        },
        laborAccountingCoefficient: 0.16,
        comment: ''
      },
      {
        id: 5,
        operation: { label: 'транспортные работы', key: 2 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 2',
          fullName: 'Исполнитель 2'
        },
        laborAccountingCoefficient: 0.16,
        comment: ''
      },
      {
        id: 6,
        operation: { label: 'транспортные работы', key: 2 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 3',
          fullName: 'Исполнитель 3'
        },
        laborAccountingCoefficient: 0.16,
        comment: ''
      },
      {
        id: 7,
        operation: { label: 'транспортные работы', key: 2 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 4',
          fullName: 'Исполнитель 4'
        },
        laborAccountingCoefficient: 0.16,
        comment: ''
      },
      {
        id: 8,
        operation: { label: 'транспортные работы', key: 2 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 5',
          fullName: 'Исполнитель 5'
        },
        laborAccountingCoefficient: 0.16,
        comment: ''
      },
      {
        id: 9,
        operation: { label: 'транспортные работы', key: 2 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 6',
          fullName: 'Исполнитель 6'
        },
        laborAccountingCoefficient: 0.16,
        comment: ''
      },
      {
        id: 10,
        operation: { label: 'строительные работы', key: 3 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 2',
          fullName: 'Исполнитель 2'
        },
        laborAccountingCoefficient: 1,
        comment: 'Сделано'
      },
      {
        id: 11,
        operation: { label: 'заключительные работы', key: 5 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 3',
          fullName: 'Исполнитель 3'
        },
        laborAccountingCoefficient: 1,
        comment: 'Сделано'
      },
      {
        id: 12,
        operation: { label: 'Свайные работы', key: 6 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 4',
          fullName: 'Исполнитель 4'
        },
        laborAccountingCoefficient: 1,
        comment: 'Сделано'
      },
      {
        id: 13,
        operation: { label: 'Бетонные работы', key: 7 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 5',
          fullName: 'Исполнитель 5'
        },
        laborAccountingCoefficient: 1,
        comment: 'Сделано'
      },
      {
        id: 14,
        operation: { label: 'Монолитные работы', key: 8 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 1',
          fullName: 'Исполнитель 1'
        },
        laborAccountingCoefficient: 1,
        comment: 'Сделано с замечаниями'
      },
      {
        id: 15,
        operation: { label: 'Каменные работы', key: 9 },
        executor: {
          id: '',
          key: '',
          label: 'Исполнитель 1',
          fullName: 'Исполнитель 1'
        },
        laborAccountingCoefficient: 1,
        comment: 'Сделано'
      }
    ];
  },

  getActualJobsSmall() {
    return Promise.resolve(this.getData().slice(0, 10));
  },

  getActualJobsMedium() {
    return Promise.resolve(this.getData().slice(0, 50));
  },

  getActualJobsLarge() {
    return Promise.resolve(this.getData().slice(0, 200));
  },

  getObjectsXLarge() {
    return Promise.resolve(this.getData());
  },

  getActualJobs(params: { [x: string]: string | number | boolean }) {
    const queryParams = params
      ? Object.keys(params)
          .map(
            (k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
          )
          .join('&')
      : '';

    return fetch(
      'https://www.primefaces.org/data/Employees?' + queryParams
    ).then((res) => res.json());
  }
};
